(function () {
  var trackedEvents = [
    'calendly.profile_page_viewed',
    'calendly.event_type_viewed',
    'calendly.date_and_time_selected',
    'calendly.event_scheduled'
  ];

  function isCalendlyEvent(event) {
    return (
      event.origin === 'https://calendly.com' &&
      event.data &&
      typeof event.data.event === 'string' &&
      event.data.event.indexOf('calendly.') === 0
    );
  }

  function getStoredUtm(key) {
    try {
      return sessionStorage.getItem('marketing_' + key) || '';
    } catch (error) {
      return '';
    }
  }

  function getUtmData() {
    return {
      utm_source: getStoredUtm('utm_source'),
      utm_medium: getStoredUtm('utm_medium'),
      utm_campaign: getStoredUtm('utm_campaign'),
      utm_content: getStoredUtm('utm_content'),
      utm_term: getStoredUtm('utm_term')
    };
  }

  function trackCalendlyEvent(event) {
    var calendlyEventName = event.data.event;

    if (trackedEvents.indexOf(calendlyEventName) === -1) {
      return;
    }

    var payload = event.data.payload || {};
    var eventName = calendlyEventName.replace('calendly.', 'calendly_');
    var utmData = getUtmData();

    var eventParameters = {
      event_category: 'Calendly',
      event_label:
        payload.event_type && payload.event_type.name
          ? payload.event_type.name
          : '',
      page_location: window.location.href,
      page_title: document.title,

      utm_source: utmData.utm_source,
      utm_medium: utmData.utm_medium,
      utm_campaign: utmData.utm_campaign,
      utm_content: utmData.utm_content,
      utm_term: utmData.utm_term
    };

    console.log('Calendly tracked:', calendlyEventName, payload);

    if (typeof window.gtag !== 'function') {
      console.warn('gtag is not available');
      return;
    }

    window.gtag('event', eventName, eventParameters);

    if (calendlyEventName === 'calendly.event_scheduled') {
      window.gtag('event', 'generate_lead', {
        source: 'calendly',
        page_location: window.location.href,
        page_title: document.title,

        utm_source: utmData.utm_source,
        utm_medium: utmData.utm_medium,
        utm_campaign: utmData.utm_campaign,
        utm_content: utmData.utm_content,
        utm_term: utmData.utm_term
      });
    }
  }

  window.addEventListener('message', function (event) {
    if (isCalendlyEvent(event)) {
      trackCalendlyEvent(event);
    }
  });
})();